import { apiResourceUrl } from "@ploy-lib/core";
import { ImageResource } from "./ImageResource";
import { BaseResource, paramsToString } from "./BaseResource";
import { ThemeResource } from "./ThemeResource";
import { schema } from "@rest-hooks/rest";
export class StyleResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.name = "";
        this.isAlternativeStyle = false;
        this.description = "";
        this.theme = ThemeResource.fromJS({});
        this.images = {};
    }
    pk() {
        return this.id?.toString();
    }
    static url(urlParams) {
        return `${super.url(urlParams)}${paramsToString(urlParams)}`;
    }
}
StyleResource.schema = {
    theme: ThemeResource,
    images: new schema.Values([ImageResource])
};
StyleResource.urlRoot = apiResourceUrl("styles");
//# sourceMappingURL=StyleResource.js.map